import type { CrmTranslate } from './crm-copy';

export function createCrmContactFormCopy(t: CrmTranslate) {
  return {
    contactForm: {
      titles: {
        create: t('crm.contactForm.titles.create'),
        edit: t('crm.contactForm.titles.edit'),
      },
      actions: {
        cancel: t('crm.contactForm.actions.cancel'),
        saving: t('crm.contactForm.actions.saving'),
        create: t('crm.contactForm.actions.create'),
        save: t('crm.contactForm.actions.save'),
        view: t('crm.contactForm.actions.view'),
        viewExistingContact: (name: string) =>
          t('crm.contactForm.actions.viewExistingContact', {
            values: { name },
          }),
      },
      labels: {
        salutation: t('crm.contactForm.labels.salutation'),
        middleName: t('crm.contactForm.labels.middleName'),
        suffix: t('crm.contactForm.labels.suffix'),
        firstName: t('crm.contactForm.labels.firstName'),
        lastName: t('crm.contactForm.labels.lastName'),
        emailRequired: t('crm.contactForm.labels.emailRequired'),
        phone: t('crm.contactForm.labels.phone'),
        mobilePhone: t('crm.contactForm.labels.mobilePhone'),
        company: t('crm.contactForm.labels.company'),
        jobTitle: t('crm.contactForm.labels.jobTitle'),
        employmentRole: t('crm.contactForm.labels.employmentRole'),
        department: t('crm.contactForm.labels.department'),
        educationLevel: t('crm.contactForm.labels.educationLevel'),
        seniority: t('crm.contactForm.labels.seniority'),
        lifecycleStage: t('crm.contactForm.labels.lifecycleStage'),
        leadStatus: t('crm.contactForm.labels.leadStatus'),
        leadScore: t('crm.contactForm.labels.leadScore'),
        contactAccuracyGrade: t('crm.contactForm.labels.contactAccuracyGrade'),
        city: t('crm.contactForm.labels.city'),
        stateRegion: t('crm.contactForm.labels.stateRegion'),
        country: t('crm.contactForm.labels.country'),
        postalCode: t('crm.contactForm.labels.postalCode'),
        address: t('crm.contactForm.labels.address'),
        externalProfileUrl: t('crm.contactForm.labels.externalProfileUrl'),
        linkedinUrl: t('crm.contactForm.labels.linkedinUrl'),
        websiteUrl: t('crm.contactForm.labels.websiteUrl'),
        companyDomain: t('crm.contactForm.labels.companyDomain'),
        companySize: t('crm.contactForm.labels.companySize'),
        latestTrafficSource: t('crm.contactForm.labels.latestTrafficSource'),
        originalTrafficSource: t('crm.contactForm.labels.originalTrafficSource'),
        contactOwner: t('crm.contactForm.labels.contactOwner'),
        hubSpotTeam: t('crm.contactForm.labels.hubSpotTeam'),
        tags: t('crm.contactForm.labels.tags'),
        externalId: t('crm.contactForm.labels.externalId'),
      },
      placeholders: {
        companySearch: t('crm.contactForm.placeholders.companySearch'),
        externalProfileUrl: t('crm.contactForm.placeholders.externalProfileUrl'),
        linkedInUrl: t('crm.contactForm.placeholders.linkedInUrl'),
        websiteUrl: t('crm.contactForm.placeholders.websiteUrl'),
        companyDomain: t('crm.contactForm.placeholders.companyDomain'),
        companySize: t('crm.contactForm.placeholders.companySize'),
        contactOwner: t('crm.contactForm.placeholders.contactOwner'),
        hubSpotTeam: t('crm.contactForm.placeholders.hubSpotTeam'),
        tags: t('crm.contactForm.placeholders.tags'),
        externalId: t('crm.contactForm.placeholders.externalId'),
      },
      emptyOptions: {
        seniority: t('crm.contactForm.emptyOptions.seniority'),
        stage: t('crm.contactForm.emptyOptions.stage'),
        status: t('crm.contactForm.emptyOptions.status'),
        source: t('crm.contactForm.emptyOptions.source'),
      },
      options: {
        junior: t('crm.contactForm.options.junior'),
        midLevel: t('crm.contactForm.options.midLevel'),
        senior: t('crm.contactForm.options.senior'),
        lead: t('crm.contactForm.options.lead'),
        manager: t('crm.contactForm.options.manager'),
        director: t('crm.contactForm.options.director'),
        vp: t('crm.contactForm.options.vp'),
        cLevel: t('crm.contactForm.options.cLevel'),
        subscriber: t('crm.contactForm.options.subscriber'),
        marketingQualifiedLead: t('crm.contactForm.options.marketingQualifiedLead'),
        salesQualifiedLead: t('crm.contactForm.options.salesQualifiedLead'),
        opportunity: t('crm.contactForm.options.opportunity'),
        customer: t('crm.contactForm.options.customer'),
        evangelist: t('crm.contactForm.options.evangelist'),
        other: t('crm.contactForm.options.other'),
        new: t('crm.contactForm.options.new'),
        open: t('crm.contactForm.options.open'),
        inProgress: t('crm.contactForm.options.inProgress'),
        openDeal: t('crm.contactForm.options.openDeal'),
        unqualified: t('crm.contactForm.options.unqualified'),
        attemptedToContact: t('crm.contactForm.options.attemptedToContact'),
        connected: t('crm.contactForm.options.connected'),
        badTiming: t('crm.contactForm.options.badTiming'),
        directTraffic: t('crm.contactForm.options.directTraffic'),
        offlineSources: t('crm.contactForm.options.offlineSources'),
        organicSearch: t('crm.contactForm.options.organicSearch'),
        paidSearch: t('crm.contactForm.options.paidSearch'),
        organicSocial: t('crm.contactForm.options.organicSocial'),
        paidSocial: t('crm.contactForm.options.paidSocial'),
        emailMarketing: t('crm.contactForm.options.emailMarketing'),
        referrals: t('crm.contactForm.options.referrals'),
        otherCampaigns: t('crm.contactForm.options.otherCampaigns'),
      },
      entitySelector: {
        createCompany: t('crm.contactForm.entitySelector.createCompany'),
        noCompaniesFound: t('crm.contactForm.entitySelector.noCompaniesFound'),
      },
      fallbacks: {
        unnamedContact: t('crm.contactForm.fallbacks.unnamedContact'),
      },
      messages: {
        duplicateEmail: (name: string) =>
          t('crm.contactForm.messages.duplicateEmail', {
            values: { name },
          }),
        emailAlreadyUsedBy: (name: string) =>
          t('crm.contactForm.messages.emailAlreadyUsedBy', {
            values: { name },
          }),
      },
    },
  };
}
